const ENDPOINT_BASE='/collections/';

export const getCollectionUrl = (code) => {
    return ENDPOINT_BASE+code;
}

export const getCollectionsUrl = () => {
    return ENDPOINT_BASE+'all';
}

export const getCreateCollectionUrl = () => {
    return ENDPOINT_BASE;
}

export const getDeleteCollectionUrl = (code) => {
    return ENDPOINT_BASE+code;
}

export const getCollectionImageUrl = (path) => {
    return process.env.REACT_APP_BASE_URL+path;
}